<template>
  <Modal
      ref="modalRef"
      :title="$t('validation.attributes.confirmation')"
      :loading="progress"
  >
    <div class="container">
      <div class="row">
        <div class="col" v-html="message" />
      </div>
      <div class="row mt-3">
        <div class="col">
          <FormControl
              ref="inputRef"
              v-model="password"
              name="password"
              type="password"
              :error="error"
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center align-items-center mt-5 gap-2">
      <Button @click="close">{{ $t('global.cancel') }}</Button>
      <Button class="btn-primary" :progress="progress"  @click="submit">{{ $t('admin.confirm') }}</Button>
    </div>
  </Modal>
</template>
<script setup>
import Modal from "@/js/Components/Modal/Modal.vue";
import Button from "@/js/Elements/Button.vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {useLoader} from "@/js/Plugins/Loader.js";
import FormControl from "@/js/Elements/Form/FormControl.vue";
import {nextTick, onMounted, ref} from "vue";
import axios from "axios";

const emit = defineEmits(['confirm']);
const props = defineProps({
  message: String,
  response: Object,
});
const progress = ref(false);
const modalRef = ref();
const password = ref();
const error = ref();
const inputRef = ref();

onMounted(() => {
  nextTick(() => {
    inputRef.value.focus();
  });
});

function submit() {
  if (props.response) {
    sendRequest();
    return;
  }

  emit('confirm', password.value);
  close();
}

function sendRequest() {
  let body = {};
  error.value = null;
  if (typeof props.response.config?.data !== 'undefined') {
    if (props.response.config.data != null && props.response.config.data.constructor.name === "Object") {
      body = props.response.config.data;
    } else if (typeof props.response.config.data === 'string') {
      body = JSON.parse(props.response.config.data);
    }
  }

  progress.value = true;
  axios({
    method: props.response.config.method,
    url: props.response.config.url,
    data: Object.assign(body, { password: password.value })
  }).then(() => {
    progress.value = false;
    emit('confirm');
    close();
  }).catch((e) => {
    const errors = e.response.data?.errors;
    error.value = errors?.message || errors?.id;
    progress.value = false;
  })
}

function close() {
  modalRef.value.close();
}
</script>